export const RESET = 'RESET_TRANSLATE'
export const SHOW_WIDGET = 'SHOW_WIDGET_TRANSLATE'
export const HIDE_WIDGET = 'HIDE_WIDGET_TRANSLATE'
export const UPDATE = 'UPDATE_TRANSLATE'
export const SHOW_PAGE_TOOLS = 'SHOW_PAGE_TOOLS_TRANSLATE'
export const HIDE_PAGE_TOOLS = 'HIDE_PAGE_TOOLS_TRANSLATE'
export const LOADED_PAGE_TOOLS = 'LOADED_PAGE_TOOLS_TRANSLATE'
export const SET_STRINGS = 'SET_STRINGS_TRANSLATE'
export const PRE_SAVE_TRANSLATION= 'PRE_SAVE_TRANSLATION_TRANSLATE'
export const SAVE_TRANSLATION = 'SAVE_TRANSLATION_TRANSLATE'
export const SEARCH = 'SEARCH_TRANSLATE'
export const SHOW_ALL_TAGS="SHOW_ALL_TAGS_TRANSLATE"
export const SHOW_PAGE_TAGS="SHOW_PAGE_TAGS_TRANSLATE"
export const NEXT_PAGE="NEXT_PAGE_TRANSLATE"
export const PREVIOUS_PAGE="PREVIOUS_PAGE_TRANSLATE"
export const TOGGLE_UNTRANSLATED="TOGGLE_UNTRANSLATED_TRANSLATE"